import { Divider, Grid, Layout, Space } from 'antd';
import { memo } from 'react';
import { Link } from 'react-router-dom';

import { useOrganization } from '../../../components/OrganizationProvider';
import { usePartnerConfig } from '../../../components/PartnerConfigProvider';
import paths from '../../../paths.json';

import styles from './styles.module.less';

const year = new Date().getFullYear();

const Footer = () => {
  const screens = Grid.useBreakpoint();
  const { legalEntity: company, supportEmail } = useOrganization();
  const { termsAndConditions, privacyPolicy } = usePartnerConfig();

  return (
    <Layout.Footer className={styles.footer}>
      <Space direction="vertical">
        <Space
          direction={screens.xs ? 'vertical' : 'horizontal'}
          size={!screens.xs ? 0 : 'small'}
          split={!screens.xs && <Divider type="vertical" />}
        >
          <span>
            Copyright © {year} {company}
          </span>
          <span>Version {VERSION}</span>
          <Space>
            Need help?
            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </Space>
        </Space>
        {(termsAndConditions || privacyPolicy) && (
          <Space size={0} split={<Divider type="vertical" />}>
            {termsAndConditions && (
              <Link target="_blank" to={paths.termsAndConditions}>
                Terms and Conditions
              </Link>
            )}
            {privacyPolicy && (
              <Link target="_blank" to={paths.privacyPolicy}>
                Privacy Policy
              </Link>
            )}
          </Space>
        )}
      </Space>
    </Layout.Footer>
  );
};

Footer.displayName = 'Footer';

export default memo(Footer);
